import React from 'react';
import { Layout } from 'react-admin';
import MyMenu from './MyMenu';
import MyNotification from './MyNotification';
import { styled } from '@mui/material/styles';

const MyLayout = (props) => {
    // const [sidebarOpen] = useSidebarState(); 

    return (
        <>
            {/* <Layout {...props} menu={MyMenu} notification={MyNotification} /> */}
            <Layout {...props} menu={MyMenu} notification={MyNotification} />;
            <Footer />
        </>
    );
};

const FooterWrapper = styled('footer', {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    position: 'fixed',
    bottom: 0,
    // left: open ? drawerWidth : closedDrawerWidth,
    right: 0,
    height: 48,
    fontSize: 12,
    zIndex: 1,
    padding: '0px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    transition: theme.transitions.create('left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const Footer = ({ open }) => (
    <FooterWrapper open={open}>
        <p>© HOLCIM {new Date().getFullYear()} | App version {process.env.REACT_APP_VERSION}</p>
    </FooterWrapper>
);


export default MyLayout;